import EnhancedEcommerce from "../enhanced-ecommerce";
import { getPayload } from "./getPayload";
import { trackEvents } from "./trackEvents";
import { TRACKING_EVENT_NAME } from "./tracking.service";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function sendProductViewEvent(pageType: any, actualResponse: any, selectedVehicle: any) {
  const { product } = actualResponse;
  const payload = getPayload(pageType, product, selectedVehicle);
  EnhancedEcommerce.addProductDetailView(payload, pageType);

  // gtag("event", TRACKING_EVENT_NAME.PRODUCT_PAGE_VIEW, {
  //   send_to: GTAG_ID,
  //   id: payload.sku,
  //   item_title: payload.sku,
  //   productLine: payload.productLine,
  //   google_business_vertical: "custom",
  //   selectedVehicle,
  //   ...payload,
  // });
  trackEvents(
    TRACKING_EVENT_NAME.PRODUCT_PAGE_VIEW,
    "view",
    payload,
  );
}
